import React, { Component } from "react";

class BubblesCanvas extends Component {
    constructor(props) {
        super(props);
        this.resize = this.resize.bind(this);
        this.drawScene = this.drawScene.bind(this);
        this.setCanvasRef = this.setCanvasRef.bind(this);
    }

    componentDidMount() {
        let canvas = this.canvas;
        // Start timer that adds animated items one at a time
        if (canvas) {
            this.drawScene();
        }
    }


    drawScene() {
        // Draw canvas for this animation frame
        this.resize();
        var canvas = this.canvas;
        var gl = canvas.getContext('webgl');
        if (gl) {
            // Vertex Shader
            var vsSource = `
            attribute vec2 position;
            void main() {
                gl_Position = vec4(position, 0.0, 1.0);
            }
        `;
            var vs = gl.createShader(gl.VERTEX_SHADER);
            gl.shaderSource(vs, vsSource);
            gl.compileShader(vs);
            if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS)) {
                console.error('Vertex shader compile error:', gl.getShaderInfoLog(vs));
                throw new Error('Vertex shader compilation failed');
            }

            // Fragment Shader (GLSL ES 1.00 compatible, using int for loop)
            var fsSource = `
            precision mediump float;
            uniform vec2 r; // resolution
            uniform float t; // time

            void main() {
                vec2 p = gl_FragCoord.xy / r.y;
                vec4 o = vec4(0.0);
                float f;
                float g = 0.0;

                for (int i = 0; i < 9; i++) {
                    vec2 temp_p = p / 0.3 + t * 0.2;
                    float fi = float(i); // Convert int to float for calculations
                    o += (cos(p.y + p.x / 0.6 + g + vec4(0.0, 1.0, 2.0, 0.0)) + 1.0) *
                         smoothstep(-9.0, 9.0, (0.3 - length(cos(temp_p))) * r.y / exp(f = sin(fi) * fi + fi)) /
                         exp(f / 3.0 + sin(fi + g + t)) *
                         (g = cos((p / 0.4).x)) * g;
                    p += vec2(1.0);
                    p *= mat2(8.0, -6.0, 6.0, 8.0) / 9.0;
                }

                // Approximate tanh(x) for GLSL ES 1.00
                vec4 temp = 0.2 * o;
                o = sqrt(temp / (1.0 + abs(temp)));
                gl_FragColor = o;
            }
        `;
            var fs = gl.createShader(gl.FRAGMENT_SHADER);
            gl.shaderSource(fs, fsSource);
            gl.compileShader(fs);
            if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) {
                console.error('Fragment shader compile error:', gl.getShaderInfoLog(fs));
                throw new Error('Fragment shader compilation failed');
            }

            // Program
            var program = gl.createProgram();
            gl.attachShader(program, vs);
            gl.attachShader(program, fs);
            gl.linkProgram(program);
            if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
                console.error('Program link error:', gl.getProgramInfoLog(program));
                throw new Error('Program linking failed');
            }

            // Validate program
            gl.validateProgram(program);
            if (!gl.getProgramParameter(program, gl.VALIDATE_STATUS)) {
                console.error('Program validation error:', gl.getProgramInfoLog(program));
                throw new Error('Program validation failed');
            }

            gl.useProgram(program);

            // Quad buffer for full-screen
            var positionBuffer = gl.createBuffer();
            gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
            gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
                -1.0, -1.0,
                1.0, -1.0,
                -1.0, 1.0,
                -1.0, 1.0,
                1.0, -1.0,
                1.0, 1.0
            ]), gl.STATIC_DRAW);

            // Set up vertex attribute
            var positionLoc = gl.getAttribLocation(program, 'position');
            if (positionLoc === -1) {
                console.error('Failed to get attribute location for position');
                throw new Error('Attribute location not found');
            }
            gl.enableVertexAttribArray(positionLoc);
            gl.vertexAttribPointer(positionLoc, 2, gl.FLOAT, false, 0, 0);

            // Uniform locations
            var rLoc = gl.getUniformLocation(program, 'r');
            var tLoc = gl.getUniformLocation(program, 't');
            if (!rLoc || !tLoc) {
                console.error('Failed to get uniform location(s)');
                throw new Error('Uniform location not found');
            }

            // Render loop
            function render(time) {
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight;
                gl.viewport(0, 0, canvas.width, canvas.height);

                gl.uniform2f(rLoc, canvas.width, canvas.height);
                gl.uniform1f(tLoc, time * 0.0003);

                gl.drawArrays(gl.TRIANGLES, 0, 6);

                requestAnimationFrame(render);
            }
            requestAnimationFrame(render);
        }
    }

    resize() {
        if (this.canvas) {
            var gl = this.canvas.getContext("webgl");
            var realToCSSPixels = window.devicePixelRatio;
            // Lookup the size the browser is displaying the canvas in CSS pixels
            // and compute a size needed to make our drawingbuffer match it in
            // device pixels.
            var displayWidth = Math.floor(gl.canvas.clientWidth * realToCSSPixels);
            var displayHeight = Math.floor(gl.canvas.clientHeight * realToCSSPixels);
            // Check if the canvas is not the same size.
            if (
                gl.canvas.width !== displayWidth ||
                gl.canvas.height !== displayHeight
            ) {
                // Make the canvas the same size
                gl.canvas.width = displayWidth;
                gl.canvas.height = displayHeight;
            }
        }
    }

    setCanvasRef(canvas) {
        this.canvas = canvas;
    }

    render() {
        return <canvas style={{ "position": "fixed", "height": "100vh", "width": "100vw", "top": 0, backgroundColor: "rgb(200, 200, 200)" }} ref={this.setCanvasRef}></canvas>;
    }
}

export default BubblesCanvas;
